export const GET_TWITTER_AUTH_URL_START = 'TWITTER/GET_TWITTER_AUTH_URL_START' as const;
export const GET_TWITTER_AUTH_URL_SUCCEED = 'TWITTER/GET_TWITTER_AUTH_URL_SUCCEED' as const;
export const GET_TWITTER_AUTH_URL_FAIL = 'TWITTER/GET_TWITTER_AUTH_URL_FAIL' as const;

export const AUTHENTICATE_START = 'TWITTER/AUTHENTICATE_START' as const;
export const AUTHENTICATE_SUCCEED = 'TWITTER/AUTHENTICATE_SUCCEED' as const;
export const AUTHENTICATE_FAIL = 'TWITTER/AUTHENTICATE_FAIL' as const;

export const CLEANUP = 'TWITTER/CLEANUP' as const;
